import { rtrim } from './rtrim';

export function numberFormat(number: number, decimals: number, decPoint: string, thousandsSep: string): string {
  const strNumber = `${number}`.replace(/[^0-9+\-Ee.]/g, '');
  let s: string[] = [];
  const n = !Number.isFinite(+strNumber) ? 0 : +strNumber;
  const precision = !Number.isFinite(+decimals) ? 0 : Math.abs(decimals);
  const sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
  const dec = typeof decPoint === 'undefined' ? '.' : decPoint;

  const toFixedFix = (numb: number, prec: number) => {
    const k = 10 ** prec;
    return `${Math.round(numb * k) / k}`;
  };

  s = (precision ? toFixedFix(n, precision) : `${Math.round(n)}`).split('.');

  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }

  if ((s[1] || '').length < precision) {
    s[1] = s[1] || '';
    s[1] += new Array(precision - s[1].length + 1).join('0');
  }

  return rtrim(s.join(dec), '0').replace(/\.$/, '');
}
